import * as Logger from '@thoughtspot/logger';
import { ExperimentationService } from './experimentation-service';
const logger = Logger.create('optimizely-notification-listners');
const EVENT_PREFIX = 'EXP_';
const FLAG_KEY = 'flagKey';
const VARIATION_KEY = 'variationKey';
export const onDecision = ({ decisionType, userId, attributes, decisionInfo, }) => {
    const properties = {};
    let experimentName = '';
    const experimentationSessionProp = {};
    for (const key in decisionInfo) {
        properties[EVENT_PREFIX + key] = decisionInfo[key];
    }
    if (FLAG_KEY in decisionInfo && VARIATION_KEY in decisionInfo) {
        experimentName = decisionInfo[FLAG_KEY];
        const variationName = decisionInfo[VARIATION_KEY];
        experimentationSessionProp[experimentName] = variationName;
    }
    try {
        ExperimentationService.getInstance().onExperimentActivated(experimentName, experimentationSessionProp, properties);
    }
    catch (err) {
        logger.error(err);
    }
};
//# sourceMappingURL=experimentation-notification-listners.js.map